// src/components/ScrollToTop.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Explicit `instant` behavior: without it, the global `scroll-behavior:
    // smooth` on <html> (index.css) turns this into an animated scroll that
    // the route change can interrupt mid-flight, leaving the page stuck
    // wherever the new content's layout happened to land (often the footer).
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null; // This component doesn't render anything
};

export default ScrollToTop;